import React from 'react';
import { Form, Input, Button } from 'antd';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Logo } from '../../assets/larvia-dark.svg';

import './LrvForm.css';

interface WebinarFormProps {
  onSubmit: (values: { name: string; email: string; company: string }) => Promise<void>;
}

const WebinarForm: React.FC<WebinarFormProps> = ({ onSubmit }) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();

  const handleFinish = async (values: { name: string; email: string; company: string }) => {
    await onSubmit(values);
    form.resetFields();
  };

  return (
    <div className="page-container">
      <div className=''><Logo /></div>

      <h1 className="webinar-title">Webinar</h1>

      <div className="form-container">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          style={{ width: '100%' }}
        >
          <Form.Item
            name="name"
            label={t('form.name')}
            rules={[{ required: true, message: t('form.errors.name') }]}
          >
            <Input size='large' placeholder={t('form.name')} />
          </Form.Item>
          <Form.Item
            name="email"
            label={t('form.email')}
            rules={[{ required: true, type: 'email', message: t('form.errors.email') }]}
          >
            <Input size='large' placeholder={t('form.email')} />
          </Form.Item>
          <Form.Item
            className='form-item'
            name="company"
            label={t('form.company')}
            rules={[{ required: true, message: t('form.errors.company') }]}
          >
            <Input size='large' placeholder={t('form.company')} />
          </Form.Item>
          <Form.Item className='form-item-button'>
            <Button className='button' type="primary" htmlType="submit">
              {t('form.access')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default WebinarForm;
